import {
  QUERY_BUILDER_OPERATORS,
  QueryBuilderOperatorType,
} from '../../../../types';

export const filterOperatorsBySearch = (
  search: string
): QueryBuilderOperatorType[] => {
  const normalizedSearch = search.trim().toLowerCase();

  if (!normalizedSearch) {
    return QUERY_BUILDER_OPERATORS;
  }

  return QUERY_BUILDER_OPERATORS.filter((operator) =>
    operator.toLowerCase().startsWith(normalizedSearch)
  );
};
